import { DirectionProvider } from "@radix-ui/react-direction";
import { createContext, useContext, useState, useEffect } from "react";
import { setSoundEnabled } from "../lib/sound";
import { translations } from "../i18n";
import { teacherize, useTeacherMode } from "../lib/teacherMode";

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("tt:lang") || "en");
  const [age, setAge] = useState(() => localStorage.getItem("tt:age") || "junior");
  const [sound, setSound] = useState(() => localStorage.getItem("tt:sound") !== "off");

  useEffect(() => {
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    localStorage.setItem("tt:lang", lang);
  }, [lang]);

  useEffect(() => {
    localStorage.setItem("tt:age", age);
  }, [age]);

  useEffect(() => {
    setSoundEnabled(sound);
    localStorage.setItem("tt:sound", sound ? "on" : "off");
  }, [sound]);

  useTeacherMode();
  const t = (key) => teacherize(translations[lang]?.[key] ?? translations.en[key] ?? key, lang);
  const dir = lang === "ar" ? "rtl" : "ltr";

  return (
    <AppContext.Provider value={{ lang, setLang, age, setAge, sound, setSound, t, dir }}>
      <DirectionProvider dir={dir}>
      {children}
      </DirectionProvider>
    </AppContext.Provider>
  );
}

export const useApp = () => useContext(AppContext);
